(() => {
  const button = document.getElementById('AmbientaWhatsApp');
  if (!button || button.dataset.v2Ready === 'true') return;

  button.dataset.v2Ready = 'true';

  const isProductPage = button.dataset.pageType === 'product';
  const hasRelevantVariant = button.dataset.hasRelevantVariant === 'true';
  const productInfo = isProductPage && button.dataset.productId
    ? document.querySelector(`product-info[data-standard-product-id="${button.dataset.productId}"]`)
    : null;
  const mainSectionId = productInfo?.dataset.section;
  let currentVariantTitle = hasRelevantVariant ? button.dataset.variantTitle : '';

  const cleanVariantTitle = (title) => {
    const value = `${title || ''}`.trim();
    return value && value.toLowerCase() !== 'default title' ? value : '';
  };

  const selectedVariantTitle = () => {
    if (!hasRelevantVariant || !productInfo) return '';

    const picker = productInfo.querySelector('variant-radios, variant-selects');
    if (!picker) return cleanVariantTitle(currentVariantTitle);

    const values = [...picker.querySelectorAll('.product-form__input--variant-picker')]
      .map((group) => {
        const radio = group.querySelector('input[type="radio"]:checked');
        if (radio) return radio.value;

        const select = group.querySelector('select');
        return select?.selectedOptions[0]?.value || '';
      })
      .filter(Boolean);

    return cleanVariantTitle(values.join(' / ') || currentVariantTitle);
  };

  const buildProductMessage = (variantTitle) => {
    let message = `${button.dataset.productMessage} ${button.dataset.productTitle}`.trim();
    if (variantTitle) message += `, variante ${variantTitle}`;
    if (button.dataset.includeUrl === 'true') message += `\n\n${button.dataset.canonicalUrl}`;
    return message;
  };

  const updateProductLink = (variantTitle = selectedVariantTitle()) => {
    if (!isProductPage) return;

    currentVariantTitle = cleanVariantTitle(variantTitle);
    const url = new URL(button.href);
    url.searchParams.set('text', buildProductMessage(currentVariantTitle));
    button.href = url.toString();
    button.dataset.variantTitle = currentVariantTitle;
  };

  if (isProductPage) {
    updateProductLink();

    document.addEventListener('afterVariantChanged', (event) => {
      if (!event.detail?.variant || `${event.detail.sectionId}` !== `${mainSectionId}`) return;
      updateProductLink(event.detail.variant.title);
    });
  }

  button.addEventListener('click', () => {
    if (isProductPage) updateProductLink(selectedVariantTitle());

    if (typeof window.clarity !== 'function') return;

    window.clarity('set', 'whatsapp_page_type', button.dataset.pageType || 'other');
    if (button.dataset.productTitle) {
      window.clarity('set', 'whatsapp_product', button.dataset.productTitle.slice(0, 255));
    }
    if (button.dataset.variantTitle) {
      window.clarity('set', 'whatsapp_variant', button.dataset.variantTitle.slice(0, 255));
    }
    window.clarity('event', 'ambienta_whatsapp_open');
  });
})();
